if($('footer#footer').length){
    $('#signature').append($('footer#footer .signatureLinks'));

    $(document).on('click', '.custom-footer>div h4', function(){
        $(this).closest('.custom-footer>div').toggleClass('openIt')
    });

    $('footer#footer .logoSocial ul.customSocial').prepend($('footer#footer .contact-box li span.instagram').closest('li'));
    $('footer#footer .logoSocial ul.customSocial').prepend($('footer#footer .contact-box li span.facebook').closest('li'));
    $('footer#footer .superContact').append($('footer#footer .contact-box li span.tel').closest('li').addClass('tel'));
    $('footer#footer .superContact').append($('footer#footer .contact-box li span.mail').closest('li').addClass('mail'));
    $('footer#footer').before($('footer#footer .customReviews'));
    $('footer#footer').before($('footer#footer .instagramFeed'));

     $(".instagram-widget>a").each(function(){
        $(".instagramFeed .igFeed").append('<div class="igPost"><a href="'+$(this).attr("href")+'" target="_blank" style="background-image: url('+$(this).find("img").attr("data-src")+')"></a></div>')
    });
    customHeader()
}else{
    if(sessionStorage.loadedFooter) {
        $('.overall-wrapper').append('<footer id="footer">'+sessionStorage.loadedFooter+'</footer>')
            customHeader()
        } else {
            $.ajax({
                type: "GET",
                dataType: "html",
                timeout: 1e4,
                cache: !0,
                url: "/",
                success: function(e) {
                    var a = shoptet.common.createDocumentFromString(e),
                    t = $(a).find("footer#footer").html();
                    null !== t && ($('.overall-wrapper').append('<footer id="footer">'+t+'</footer>'))
                    sessionStorage.loadedFooter = $("footer#footer").html();
                    customHeader()
                    }
            });
        }
}

function customHeader(){
    if($('footer#footer .custom-footer__banner14').length){
        $('nav#navigation ul.menu-level-1>li.menu-item-710 ul.menu-level-2').append('<li class="customMenuBanner">'+$('footer#footer .custom-footer__banner14 .banner-wrapper').html()+'</li>')
    }
}